import React, { cloneElement } from 'react';

// BOOTSTRAP COMPONENTS
import clsx from 'clsx';
import { Badge } from 'react-bootstrap';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';
import Sprite from 'core/tools/Sprite';

// HELPERS
import { useDetail } from '../helpers/DetailProvider';

// STYLES
import styles from './card.module.scss';

// MAIN COMPONENT
const SectionCard = ({ number, title, body, color = 'green', tools, readOnly, className }) => {
  return (
    <div className="position-relative">
      <div id={number} className={clsx('position-absolute', styles.anchor)} />
      <Card
        header={<Header number={number} title={title} tools={tools} readOnly={readOnly} />}
        body={body}
        className={clsx(styles.card, color, className)}
      />
    </div>
  );
};

// EXPORT
export default SectionCard;

function Header({ number, title, tools = [], readOnly }) {
  const { currentNumber } = useDetail();

  return (
    <div className="d-flex align-items-center w-100">
      <Badge className={clsx('me-3', styles.badge)}>{number}</Badge>
      {!readOnly && currentNumber && number === currentNumber ? (
        <Sprite use="arrow-circle-left" fill="green" size="lg" className="me-2" />
      ) : null}
      <Card.Title >
        <span className="me-2">{title}</span>
        {tools?.length ? (
          <span className="d-inline-block mt-1 align-middle">
            {tools.map((tool, i) => cloneElement(tool, { key: i, ...tool.props }))}
          </span>
        ) : null}
      </Card.Title>
    </div>
  );
}
